import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import productGridReviews from '../features/product-grid';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';

register('product-grid', [productGridReviews, slider, quickAddProduct, swatchGridSection]);
